import axios from "axios";
import config from "../config";
import authHeader from "./auth-header";

const API_URL = config.API_URL;

const view = (values) => {
  const sort = values && values.sort;
  const page = values && values.page;
  const next_page_url = values && values.next_page_url;
  const result = values && values.result ? values.result : "";
  let sortstring = "";
  if (sort) {
    let sortArray = [];
    Object.keys(sort).map(function (key, index) {
      sortArray[index] = `sort[${key}]=${sort[key]}`;
    });
    if (sortArray.length > 0) {
      let jsort = sortArray.join("&");
      sortstring = jsort;
    }
  }
  let pagination = true;
  if (values) {
    if (values.id) {
      pagination = false;
    }
    if (values.option) {
      pagination = false;
    }
    if (values.pagination) {
      pagination = values.pagination;
    }
  }
  const action = page ? `afterlogin/tax/view?page=${page}&${sortstring}` : `afterlogin/tax/view?${sortstring}`;
  const data = {
    pagination: pagination, //true or false
    id: values && values.id ? values.id : "",
    result: result, //business_name,owner_name
    option: values && values.option ? values.option : "",
  };
  return axios.post(next_page_url ? `${next_page_url}&${sortstring}` : API_URL + action, data, { headers: authHeader() });
};
const taxvalue = (values) => {
  const action = `afterlogin/tax/percentage`;
  const data = {
    name: values && values.name,
  };
  return axios.post(API_URL + action, data, { headers: authHeader() });
};
const taxApiController = {
  view,
  taxvalue,
};
export default taxApiController;
